import {
  TPatchUser,
  TPostUser,
  TQueryUser,
  TSetPassword,
  TChangePointUser,
  TUser,
  TChangePointUsers,
} from '@src/modules'
import { TResDataListApi } from '@src/configs/interface.config'

import { request } from './config'

export const getProfile = (token: string) => request({ url: 'user/profile', method: 'GET' }, { token })
export const updateProfile = (data: TPatchUser, token?: string) =>
  request({ url: 'user/profile', method: 'PATCH', data }, { token })
export const getListUser = (params: TQueryUser, token: string) =>
  request({ url: 'user', method: 'GET', params }, { token })
export const getUserById = (id: string, token: string) => request({ url: `user/${id}`, method: 'GET' }, { token })
export const postUser = (data: TPostUser) => request({ url: 'user', method: 'POST', data })
export const patchUserById = (id: string, data: TPatchUser) => request({ url: `user/${id}`, method: 'PATCH', data })
export const patchPasswordUserById = (id: string, data: TSetPassword) =>
  request({ url: `user/${id}/set-password`, method: 'PATCH', data })
export const changePointUser = (data: TChangePointUser) => request({ url: `user/credit-point`, method: 'POST', data })
export const changeMultiplePointUser = (data: TChangePointUsers) =>
  request({ url: `user/credits-point`, method: 'POST', data })
export const removeUserById = (id: string) => request({ url: `user/${id}`, method: 'DELETE' })
export const removeManyUserByIds = (ids: string[]) =>
  request({ url: `user/delete-many`, method: 'POST', data: { ids } })
export const activeUsers = (ids: string[], isActive: boolean) =>
  request({ url: 'user/active-user', method: 'PATCH', data: { userIds: ids, isActive } })
export const getTotalUser = (token?: string) => request({ url: `user/total`, method: 'GET' }, { token })
export const importPoint = (data: FormData, token: string): Promise<TResDataListApi<TUser[]>> =>
  request(
    {
      url: `user/import-point`,
      method: 'POST',
      data,
      headers: {
        Accept: 'application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data, application/x-www-form-urlencoded;charset=utf-8',
      },
      transformRequest: [() => data],
    },
    { token },
  )
export const exportListUser = (params: TQueryUser, token: string) =>
  request(
    {
      url: 'user/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token },
  )
export const importChosenUsers = (data: FormData, token?: string) =>
  request(
    {
      url: `user/chosen-user`,
      method: 'POST',
      data,
      headers: {
        Accept: 'application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data, application/x-www-form-urlencoded;charset=utf-8',
      },
      transformRequest: [() => data],
    },
    { token },
  )
